// KycCompletePage — final confirmation screen after KYC submission.
// Renders inside OnboardingShell with stage="active" so the left rail
// reflects the just-completed transition to active member.

import React from "react";
import { Link } from "react-router-dom";
import { Check, Mail, ShieldCheck, Wallet, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { OnboardingShell } from "@/components/shells/OnboardingShell";

export default function KycCompletePage() {
  return (
    <OnboardingShell currentStage="active">
      <div data-testid="kyc-complete-page" className="max-w-xl">
        <div className="inline-flex items-center justify-center size-16 rounded-full bg-emerald-50 text-emerald-700 mb-6">
          <Check className="size-8" />
        </div>
        <div className="eyebrow mb-3 text-brand-700">Active member</div>
        <h1 className="font-brand text-[40px] lg:text-[44px] leading-[1.05] tracking-[-0.025em] text-ink font-bold">
          You&rsquo;re in.
        </h1>
        <p className="mt-5 text-body text-ink-muted leading-relaxed">
          Identity check complete. Your Gift Card Buyers Club account is active.
          Check your inbox &mdash; we&rsquo;ve emailed your sign-in credentials.
        </p>

        <div className="mt-9 grid grid-cols-3 gap-3">
          <Tile icon={Mail}        label="Email sent" sub="Login credentials" />
          <Tile icon={ShieldCheck} label="Identity"   sub="Verified" />
          <Tile icon={Wallet}      label="Bank"       sub="Captured" />
        </div>

        <div className="mt-10 flex items-center gap-3">
          <Link to="/login">
            <Button className="bg-brand-700 hover:bg-brand-800 text-white h-12 px-6" data-testid="kyc-complete-cta">
              Go to sign-in <ArrowRight className="size-4 ml-2" />
            </Button>
          </Link>
          <Link to="/" className="text-caption font-semibold text-ink-muted hover:text-ink">Back to home</Link>
        </div>

        <p className="mt-10 pt-6 border-t border-line text-caption text-ink-subtle">
          Didn&rsquo;t get the email? Check spam, or wait a minute &mdash; delivery can take 30 seconds.
        </p>
      </div>
    </OnboardingShell>
  );
}

function Tile({ icon: Icon, label, sub }) {
  return (
    <div className="bg-surface-alt border border-line rounded-md p-4">
      <Icon className="size-4 text-brand-700" />
      <div className="mt-2 text-caption font-semibold text-ink">{label}</div>
      <div className="text-[10px] text-ink-subtle">{sub}</div>
    </div>
  );
}
